import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

let cachedSettings = null;
let fetchPromise = null;

export const useSettings = () => {
  const [settings, setSettings] = useState(cachedSettings || { qrCodeUrl: '', whatsappNumber: '01167659164' });

  useEffect(() => {
    if (cachedSettings) { setSettings(cachedSettings); return; }
    if (!fetchPromise) {
      fetchPromise = fetch(`${API_URL}/api/settings`)
        .then(res => res.json())
        .then(data => { cachedSettings = data; return data; })
        .catch(() => ({ qrCodeUrl: '', whatsappNumber: '01167659164' }));
    }
    fetchPromise.then(data => setSettings(data));
  }, []);

  return settings;
};
